import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_USU_PROFESIONES = 'ALL_USU_PROFESIONES';
export const LOADING_ALL_USU_PROFESIONES = 'LOADING_ALL_USU_PROFESIONES';
export const ACTIVO_USU_PROFESIONES = 'ACTIVO_USU_PROFESIONES';
export const PARAMS_USU_PROFESIONES = 'PARAMS_USU_PROFESIONES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const usuProfesionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_USU_PROFESIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_USU_PROFESIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_USU_PROFESIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_USU_PROFESIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
